<template>
    <div class="dropdown-block" v-click-outside="onClickOutside" >
        <label class="dropdown-label">{{label}}</label>
        <div class="dropdown -big" :class="{active: isOpen}">
            <div class="selected" :class="{'placeholder-active': !selected}"  @click="toggle">
                <span v-if="type === 'tourniquet'">{{ selected && selected.name || placeholder }}</span>
                <span v-if="type === 'test'" class="dropdown-test-selected-container">
                    <span v-if="selected" class="dropdown-test-selected">
                        <span class="option-test-title">
                            <span v-for="(org, index) in selected.organizations" :key="index">
                                {{org.name}} <span v-if="index !== selected.organizations.length - 1">, </span>
                            </span>
                        </span>
                        <span class="option-test-info-date bg-neutral">{{selected.date}}</span>
                        <span class="option-test-info-status" :class="getTestClass(selected.status)">{{selected.resolution}}</span>
                    </span>
                    <span v-else>
                        {{placeholder}}
                    </span>
                </span>
                <Chevron class="arrow"/>
            </div>
            <div class="options" v-show="isOpen">
                <div v-if="options.length">
                    <div class="option" :class="{active: selected === option}" v-for="option in options" @click="set(option)">
                        <div v-if="type === 'tourniquet'">
                            <span>{{ option.name }}</span>
                            <span class="text-second">({{ option.manufacturer }})</span>
                        </div>
                        <div v-else-if="type === 'test'" class="option-test">
                            <div class="option-test-header">
                                <span class="option-test-logo-block">
                                    <span v-for="(org, index) in option.organizations" :key="index" class="option-test-logo">
                                         <picture v-if="org.images">
                                            <source :srcset="`${org.images.webp['size-30']} 1x, ${org.images.webp['size-60']} 2x`" type="image/webp">
                                            <source :srcset="`${org.images.photo['size-30']} 1x, ${org.images.photo['size-60']} 2x`" type="image/jpeg">
                                            <img :src="org.images.photo['size-30']" alt="logo" loading="lazy" :width="30" :height="30">
                                        </picture>
                                    </span>
                                </span>
                                <span class="option-test-title">{{option.organizations[0] ? option.organizations[0].name : ''}}</span>
                            </div>
                            <div class="option-test-info">
                                <span class="option-test-info-date bg-neutral">{{option.date}}</span>
                                <span class="option-test-info-status" :class="getTestClass(option.status)">{{option.resolution}}</span>
                            </div>
                        </div>
                        <Check v-if="selected === option"/>
                    </div>
                </div>
                <div v-else class="option">Немає данних</div>
            </div>
        </div>
    </div>
</template>

<script>
import Chevron from "../icons/IconChevron.vue";
import Check from "../icons/IconCheck.vue";

Vue.directive("click-outside", {
    bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});

export default {
    name: "FormDropdown",
    props: ['name', 'options', 'placeholder', 'label', 'type', 'selectedDefault'],
    emits: ['setSelection'],
    data: function() {
        return {
            isOpen: false,
            selectedFormDropdown: null,
        }
    },
    computed: {
        selected() {
            return this.selectedFormDropdown !== null ? this.options[this.selectedFormDropdown] : this.options[this.selectedDefault]
        }
    },
    methods: {
        toggle: function() {
            this.isOpen = !this.isOpen;
            if (this.isOpen && this.type === 'tourniquet' && this.options.length < 2) {
                this.$emit('fetchlist');
            }
        },
        hide: function() {
            this.isOpen = false;
        },
        set: function(option) {
            this.selectedFormDropdown = this.options.findIndex(item => item.id === option.id);
            this.$emit('setselection', this.type === 'test' ? this.selected.id : this.selected.name, this.type === 'test' ? this.getTestText() : this.selected.alias);
            if (this.type === 'tourniquet') {
                this.$emit('selecttourniquet', this.selected.id);
            }
            this.hide()
        },
        onClickOutside () {
            this.hide();
        },
        getTestClass(status) {
            switch (status){
                case 2: return 'bg-neutral';
                case 1: return 'bg-success';
                case 0: return 'bg-danger';
                case 3: return 'bg-warning';
            }
        },
        getTestText() {
            let orgs = []
            this.selected.organizations.forEach(org => orgs.push(org.name))
            let text = orgs.toString();
            text = text + ' ' + this.selected.date + ' ' + this.selected.resolution
            return text;
        }
    },
    components: {Chevron, Check}
}
</script>
<style lang="scss" scoped>
@import "../../../../sass/front/helpers";

.text-second {
    color: #959595;
}

.option-test {

    &-logo {
        width: 3.6rem;
        height: 3.6rem;
        background: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        & + & {
            margin-left: -2rem;
        }

        &-block {
            display: flex;
            align-items: center;
        }
    }

    &-title {
        font-weight: 500;
        font-size: 1.3rem;
        display: block;
    }

    &-header {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    &-info {
        display: flex;
        gap: 1rem;
        align-items: center;
        margin-top: 0.5rem;
        padding-left: 4rem;

        &-date {
            font-weight: 300;
            font-size: 1.1rem;
            border-radius: 0.5rem;
            padding: 0.4rem 0.5rem;
        }

        &-status {
            font-weight: 300;
            font-size: 1.1rem;
            border-radius: 0.5rem;
            padding: 0.4rem 0.5rem;
        }
    }
}

.dropdown {
    position: relative;

    &.active {
        .selected {
            border-color: $text-main;
        }

        .arrow {
            transform: rotate(180deg);
        }
    }

    @include responsive-below($sm){
        width: 100%;
    }

    &-block {
        margin-top: 2rem;
    }

    &-label {
        font-size: 1.1rem;
        font-weight: 300;
        color: rgba(37, 37, 37, 0.5);
        margin-bottom: 0.4rem;
        display: block;
    }

    .selected {
        border: 1px solid #EBEBEB;
        border-radius: 8px;
        padding: 1.5rem;
        font-size: 12px;
        cursor: pointer;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > svg {
            margin-left: 5px;
        }

        @include responsive-below($sm){
            border-top: 0;
            border-right: 0;
            border-left: 0;
            border-radius: 0;
            font-size: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
        }
    }

    .options {
        position: absolute;
        left: 0;
        z-index: 2;
        top: calc(100% + 10px);
        background: #FDFDFD;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08), 0px 0px 1px rgba(67, 90, 111, 0.47);
        border-radius: 8px;
        padding: 5px;
        min-width: 160px;

        @include responsive-below($sm){
            width: 100%;
        }

        .option {
            cursor: pointer;
            border-radius: 6px;
            margin-bottom: 8px;
            padding: 10px;
            display: flex;
            gap: 10px;
            justify-content: space-between;
            width: 100%;

            &.active {
                background: #F4F4F4;
            }

            &:hover {
                background: rgba(248, 248, 248, 0.78);
            }
        }
    }

    &.open {
        .selected {
            border: 0;
            font-size: 16px;
        }
        .options {
            position: static;
            box-shadow: none;
            background-color: #fff;

            .option {
                justify-content: flex-start;
                align-items: center;
                gap: 10px;
                font-size: 14px;
                font-weight: 300;
                margin-bottom: 0;
                padding: 10px 0;

                &.active {
                    background-color: #fff;
                }
            }
        }
    }

    &-test-selected {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        max-width: 100%;
        overflow: hidden;

        &-container {
            max-width: calc(100% - 13px);
        }
    }
}

.selected.placeholder-active {
    font-weight: 300;
    color: #7D7D7D;
}

.dropdown.-big {
    .selected {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        height: 5.5rem;
    }

    .options {
        width: 100%;
        max-height: 250px;
        overflow: auto;

        &::-webkit-scrollbar {
            z-index: 50;
            width: 4px;
            height: 4px;
            background-color: #cccccc;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #adadad;
            border: 1px solid #ADADADFF;
            border-radius: 8px;
        }
    }
}
</style>
